import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useReducedMotion } from 'framer-motion';
import { Nav } from './Nav';
import { Footer } from './Footer';
import { SAMPLE_HREF } from '../lib/links';
interface SiteLayoutProps {
  children: React.ReactNode;
}
export function SiteLayout({
  children
}: SiteLayoutProps) {
  const location = useLocation();
  const navigate = useNavigate();
  const reduceMotion = useReducedMotion();
  const isHome = location.pathname === '/';
  useEffect(() => {
    // Older links pointed at the sample on the homepage. Send them to its new page.
    if (isHome && location.hash === '#lesson') {
      navigate(SAMPLE_HREF, {
        replace: true
      });
      return undefined;
    }

    // Scroll to a hash target after the route renders, or to the top.
    if (location.hash) {
      const id = decodeURIComponent(location.hash.slice(1));
      const timer = window.setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({
          behavior: reduceMotion ? 'auto' : 'smooth',
          block: 'start'
        });
      }, 40);
      return () => window.clearTimeout(timer);
    }
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
    return undefined;
  }, [isHome, location.pathname, location.hash, location.key, navigate, reduceMotion]);
  return <div className={`flex min-h-screen w-full flex-col overflow-x-clip ${isHome ? 'bg-lavender' : 'bg-cream'}`} data-id="element-304" data-mp="38o4so1detuuq">
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-6 focus:top-4 focus:z-50 focus:rounded-xl focus:bg-ink focus:px-4 focus:py-2 focus:text-cream" data-id="element-305" data-mp="a6ip7ua8yhae">
        Skip to content
      </a>
      <Nav data-id="element-306" data-mp="ev0i152recm" />
      <main id="main" className="flex-1" data-id="element-307" data-mp="ecz6q3k29xu">
        {children}
      </main>
      <Footer data-id="element-308" data-mp="3rlz5yrlkmsix" />
    </div>;
}